
export default class DeviceInfo {
  code: string;

  id: number;

  name: string;

  eqCd?: string = '';

  constructor(id: number) {
    this.code = '';
    this.id = id;
    this.name = '';
  }
}